export const environment = {
    production: false,
    testing: false,
    development: false,
    training: true,
    hasServiceWorker: true,
    theme: 'trng',
    appUrl: 'https://pawstraining.usask.ca/login', //Example: https://myapp.com
    casUrl: 'https://cas.usask.ca/cas', //Example: https://mycas.com/cas
    casValidateUrl: 'https://cas.usask.ca/cas/serviceValidate', //Example: https://mycas.com/cas/serviceValidate
    casClientID: "pawstrng",
    pubDate: "Thu 06 Aug 2026 10:00:01 AM CST",
    revision: "1.1.19.1786032001",
    webPath: "/",
    domain: "pawstraining.usask.ca",
    apiURL: "https://pawstraining.usask.ca/pawsapi/api",
    chatAPI: "https://pawstraining.usask.ca/uchat/api", // "https://portalapps.usask.ca/uchat/api", //https://pawsdev.usask.ca/uchat/api",
    myProfileLink: "https://myprofile.usask.ca/home.jsf",
    helpLink: "https://teamdynamix.usask.ca/TDClient/33/Portal/KB/ArticleDet?ID=274", //https://wiki.usask.ca/x/AIGybw",
    sorryLink: "https://sorry.usask.ca/paws_down.html",
    applCategories: "PASS,EVAL,OTPT,EMRG,UOFS,NEWS,FEAT",
    oldPAWSLink: "https://pawstrng.usask.ca",
    countdownEventsUrl: "https://portalapps.usask.ca/countdown_events/countdown_eventgenerator.php?v=4",
    announcementURL: "https://portalapps.usask.ca/announcements/",
    TARole: "imported_groups",
    maxRecentlyViewedSize: 3,
    emailIconName: "Email",
    pageTitle: "PAWS TRNG",
    unreadExpiryTime: 15,
    enableGA: false,
    gaTrackingId: "G-F8YQ9ND9X3",
    notificationTimeout: 5000,
    checkForUpdatesInterval: ( 5 * 60 * 1000 ),
    logLevel: "ERROR",
    RTLifetimeInMinutes: 90,
    sessionTimeoutShowNotificationInSeconds: 90,
    showIneligibleChannels: true,
    showChannelEligibility: false,
    showChannelListRoleFilter: true,
    feature_UsaskSearch: true,
    feature_SearchFeedback: true,
    feature_DigitalAssistant: false,
    feature_O365: false,
    feature_studentEnrollment: false,
    feature_CountdownEvents: false,
    feedbackPostURL: "https://phpapps.usask.ca/site-feedback/feedback_post.php",
    searchPageSize: 15,
    CPKBUrl: "https://jira.usask.ca/servicedesk/customer/portal/1",
    LBKBUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=3", //https://jira.usask.ca/servicedesk/customer/portal/13",
    ITSUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=1", // https://teamdynamix.usask.ca/TDClient/33/Portal/KB/?CategoryID=1",
    STUKBUrl: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?ReturnUrl=%2fTDClient%2f33%2fPortal%2fKB%2f?CategoryID=2", ///https://jira.usask.ca/servicedesk/customer/portal/7",
    aiPilotRole: "digital_assistant_pilot",
    employeeVisibleRoles: "employee,advisor,advisor_admin",
    MyCollegeCategoryID: 8,
    usaskAnnouncementLabelsIds: "1",
    hiddenCategories: "Icon,HIDDEN",
    gonamesWithDisabledBreadcrumbs:"",
    itSupportSubmitLink: "https://teamdynamix.usask.ca/TDClient/33/Portal/Requests/ServiceDet?ID=95",
    TDxLoginURL: "https://teamdynamix.usask.ca/TDClient/33/Portal/Login.aspx?returnURL=",
    MSOAuth_GraphAPI: "https://graph.microsoft.com/v1.0",
    MSOAuth_appID: '',
    MSOAuth_tenant: '',
    MSOAuth_redirectUri: 'https://pawstraining.usask.ca/msal',
    MSOAuth_scopes: ['User.Read', 'Calendars.ReadBasic'],
    MSOAuth_loginHint: "usask.ca",
};
